var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6094 5.20767C20.7136 5.28773 20.801 5.38755 20.8666 5.50141C20.9322 5.61527 20.9747 5.74094 20.9917 5.87124C21.0087 6.00154 20.9998 6.13391 20.9657 6.26078C20.9315 6.38766 20.8726 6.50655 20.7924 6.61067L10.7924 19.6107C10.7057 19.7234 10.5959 19.8164 10.4703 19.8833C10.3448 19.9502 10.2064 19.9896 10.0644 19.9988C9.92242 20.008 9.78011 19.9868 9.64699 19.9366C9.51387 19.8863 9.39299 19.8083 9.29243 19.7077L4.29243 14.7077C4.11027 14.5191 4.00948 14.2665 4.01176 14.0043C4.01403 13.7421 4.1192 13.4913 4.30461 13.3058C4.49002 13.1204 4.74083 13.0153 5.00303 13.013C5.26523 13.0107 5.51783 13.1115 5.70643 13.2937L9.90143 17.4887L19.2064 5.39067C19.2865 5.28648 19.3863 5.19909 19.5002 5.1335C19.614 5.0679 19.7397 5.0254 19.87 5.0084C20.0003 4.9914 20.1327 5.00026 20.2595 5.03445C20.3864 5.06864 20.5053 5.1275 20.6094 5.20767Z",
    fill: "#ffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.19b13fdd955fc052f01c08416ffabbc8.svg";
export { ForwardRef as ReactComponent };